module.exports = __webpack_public_path__ + "static/img/15.f00a5f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/trainPlan/10sportDesc/15.svg
// module id = CpQ5
// module chunks = 0